import ButtonLoading from './styled';

export default ButtonLoading;
